import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { InputComponent } from '../input/input.component';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { FiltreService } from '../../filtre.service';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-string-input',
  templateUrl: './string-input.component.html'
})
export class StringInputComponent extends InputComponent {
  @Input()
  longueurMax = 1000;
  @Input() placeholder = '';
  libelle$: BehaviorSubject<string>;
  constructor(
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
    ) {
      super(formulaireService, libelleService, filtreService, modeRenduService);
  }
}
